import src from "IMAGE";
export default { src, width: 200, height: 54, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ACQkJEE1NTVhHh4eODo6OnA1NTVmPDw8c0JCQn4fHx85AC0tLVI5OTlpLS0tVEVFRYVCQkKAPDw8dEFBQX0UFBQl7u4Pj8ix/f4AAAAASUVORK5CYII="};
